import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { FiAlignRight, FiXCircle } from "react-icons/fi";

const Navigation = () => {
  const [isMenu, setisMenu] = useState(false);
  const [isResponsiveclose, setResponsiveclose] = useState(false);

  const toggleClass = () => {
    setisMenu(isMenu === false ? true : false);
    setResponsiveclose(isResponsiveclose === false ? true : false);
  };

  let boxClass = ["main-menu"];
  if (isMenu) {
    boxClass.push('menuq2');
  } else {
    boxClass.push('');
  }

  return (
    <div className="header__middle">
      <div className="head-container">
        <div className="header__middle__menus">
          <nav className="main-nav ">
            {isResponsiveclose === true ? (
              <>
                <span
                  className="menubar__button"
                  style={{ display: "none" }}
                  onClick={toggleClass}
                >
                  <FiXCircle />
                </span>
              </>
            ) : (
              <>
                <span
                  className="menubar__button"
                  style={{ display: "none" }}
                  onClick={toggleClass}
                >
                  <FiAlignRight />
                </span>
              </>
            )}
            <ul className={boxClass.join(" ")}>
              <li className="menu-item">
                <NavLink onClick={toggleClass} exact activeClassName="is-active" className="nav-links" to="/Salesforce/Courses"> Courses </NavLink>
              </li>
              <li className="menu-item">
                <NavLink onClick={toggleClass} exact activeClassName="is-active" className="nav-links" to="/Salesforce/LearningPaths"> Learning Paths </NavLink>
              </li>
              <li className="menu-item">
                <NavLink onClick={toggleClass} exact activeClassName="is-active" className="nav-links" to="/Salesforce/Testimonials"> Testimonials </NavLink>
              </li>
              <li className="menu-item">
                <NavLink onClick={toggleClass} exact activeClassName="is-active" className="nav-links" to="/Salesforce/LkmExperts"> LKM Experts </NavLink>
              </li>
              {/* <li className="menu-item">
                      <NavLink onClick={toggleClass} exact activeClassName="is-active" className="nav-links" to="/Salesforce/calendar"> Calendar </NavLink>
                  </li> */}
              <li className="menu-item">
                <a
                  onClick={toggleClass}
                  activeClassName="is-active"
                  className="nav-links"
                  target="_blank"
                  href="https://atci.lkm.eitacademy.accenture.com/SalesforceAcademy/salesforce-calendar/"
                  rel="noreferrer"
                >
                  Calendar
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  )
}

export default Navigation;